import React, { useState } from 'react';

import { Box, Button, Grid, Link, Typography } from '@material-ui/core';

import WhatsappSrc from '../../assets/img/whatsapp_white.svg';
import { appConfig } from '../../config/app';
import SharedDialog from '../SharedDialog/SharedDialog.component';

interface DialogProps {
  is_open: boolean;
  title?: string;
  message?: string;
  close_dialog: () => void;
}

const WhatsappDialog: React.FC<DialogProps> = ({
  is_open,
  title,
  message,
  close_dialog,
}) => {
  return (
    <SharedDialog
      title={title}
      open={is_open}
      content={
        <Box>
          <Typography display="block" variant="h6">
            {message}
          </Typography>
        </Box>
      }
      onClose={close_dialog}
      actions={
        <Grid container justify="center">
          <Grid item xs={12} sm={6}>
            <Box m={2}>
              <Button
                variant="outlined"
                color="secondary"
                fullWidth
                onClick={close_dialog}
              >
                Entendido
              </Button>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Box m={2} display="flex" alignItems="center">
              <Link
                rel="noopener"
                target="_blank"
                href={appConfig?.WHATSAPP_LINK}
              >
                <Button variant="contained" color="primary" fullWidth>
                  <Box>
                    <img
                      src={WhatsappSrc}
                      alt="Whatsapp"
                      style={{ marginLeft: '15px', marginRight: '15px' }}
                    />
                  </Box>
                  <Typography display="inline">
                    Comunicarme vía Whatsapp
                  </Typography>
                </Button>
              </Link>
            </Box>
          </Grid>
        </Grid>
      }
    ></SharedDialog>
  );
};

export default WhatsappDialog;
